export abstract class BaseModel {

  id:number;

  protected static fromJson(jsonData:any) : BaseModel {
    return null;
  };
}
